import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const Connectivity = ({ onConnectivitySelected }) => {
  const [selectedConnectivity, setSelectedConnectivity] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.connectivity) {
        const connectivityObject = firstResult.connectivity;
        if (connectivityObject.trim() !== "") {
          setVariations(connectivityObject.split(","));
        }
      }
    } catch (error) {
      console.error("Error fetching product variations:", error);
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleConnectivityClick = (connectivity) => {
    setSelectedConnectivity(connectivity);
    onConnectivitySelected(connectivity);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Connectivity:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedConnectivity === variation ? "selected" : ""}`}
            onClick={() => handleConnectivityClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default Connectivity;
